export const NETSUITE_CONNECTION_STATUS = {
    LINKED: 'linked',
    CONNECTED: 'connected'
};